export enum settingActions {
  treat = "Marqué comme traité",
  refuse = "Refuser",
  delete = "Supprimer",
  edit = "Modifier",
  taggedSpec = "Modification spec."
}